<studio-button-legacy theme="dark-secondary" [class.inactive]="!active" [attr.title]="tooltip">
  <studio-icon [name]="active ? iconActive : iconInactive"></studio-icon>
  <studio-icon *ngIf="showWarning" class="warning" name="alert"></studio-icon>
</studio-button-legacy>
